export type ErrorMessage = {
  [key: number]: string
}

export const errorMessagesByCode: ErrorMessage = {
    413: 'Tamanho do arquivo muito grande!',
    504: 'Tempo limite excedido, tente novamente.'
}